import React from 'react';
import pull = require("lodash/pull");
import {lovLabel, lovValue, FormProps, ClosedContentProps} from 'core/form/formUtils';
import {createForm} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {MdIconButton} from "core/components/buttons/icons";
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import Add from "material-ui/svg-icons/content/add";
import {addSeparator} from "core/common/utils/arrayUtils";
import {MdDivider} from "core/components/blockComp/blockComp";
import {CONFIGLEVEL} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {ObservableMap, action} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {
  MdEntityDto,
  EntityValidationTable
} from "core/metamodel/metaDomain";
import {optionsSearch} from "core/common/service/commonDataService";

interface EntityValidationListProps {
  entityObject: MdEntityDto;
  rootObject: MdEntityDto;
  entities: ObservableMap<MdEntity>;
  entity: MdEntity;
}

@observer
export default class EntityValidationList extends React.Component<EntityValidationListProps, undefined> {


  @action addValidation = () => {
    console.debug('addValidation');
    const {entityObject, rootObject} = this.props;
    let newValidation = new EntityValidationTable({
      $new: true,
      $added: true,
      entityName: entityObject.mdEntity,
      configLevel: CONFIGLEVEL.GLOBAL
    });
    entityObject.validations.push(newValidation);
    rootObject.$dirty = true;
  };



  render() {

    const {entityObject, entities, entity, rootObject} = this.props;

    const header = (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <div>Entity Validations</div>
        <MdIconButton onClick={this.addValidation}>
          <Add />
        </MdIconButton>
      </div>
    );

    return (
      <BlockComp header={header}  noPadding={true} style={{display: 'flex', flexDirection: 'column'}} >
        {
          addSeparator( entityObject.validations.map((ev, index) => <EntityValidationTableForm dataObject={ev} rootObject={rootObject} key={index}
                                                                                              entities={entities} entity={entity}
                                                                                              index={index} /> ), <MdDivider inset/>)
        }
      </BlockComp>
    );
  }
}





const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<EntityValidationTable>) => (
  <div style={{display: 'flex', fontSize: 16, lineHeight: '14px'}}>
    <div className="zz-grey-text zz-mr-5">{lovLabel(dataObject.configLevel)}</div>
    { (lovValue(dataObject.configLevel) === CONFIGLEVEL.TENANTGROUP) ? <div className="zz-grey-text">{lovLabel(dataObject.tenantGroup)}</div> : null}
    { (lovValue(dataObject.configLevel) === CONFIGLEVEL.TENANT) ? <div className="zz-grey-text">{lovLabel(dataObject.tenant)}</div> : null}
    { (lovValue(dataObject.configLevel) === CONFIGLEVEL.USER) ? <div className="zz-grey-text">{lovLabel(dataObject.user)}</div> : null}
    { (dataObject.language) ? <div className="zz-grey-text zz-ml-5">({lovLabel(dataObject.language)})</div> : null}
    <div className="zz-ml-10">
      {lovLabel(dataObject.validation)}
    </div>
  </div>
);

@createForm({
  formName: 'EntityValidationTableForm',
  fields: [{
    name: 'validation'
  }, {
    name: 'tenantGroup',
    validators: ['IsRequired']
  }, {
    name: 'tenant',
    validators: ['IsRequired']
  }, {
    name: 'user',
    validators: ['IsRequired']
  }, {
    name: 'configLevel',
    validators: ['IsRequired']
  }, {
    name: 'language'
  }]
}, ClosedContent)
@observer
class EntityValidationTableForm extends React.Component<FormProps<EntityValidationTable, MdEntityDto>, undefined> {

  @action onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);
    pull(this.props.rootObject.validations, this.props.dataObject);
  };

  @action handleConfigLevelChange = () => {
    let {dataObject, rootObject, formName} = this.props;
    console.log('handleConfigLevelChange ', dataObject.configLevel);

    dataObject.tenant = null;
    dataObject.tenantGroup = null;
    dataObject.user = null;

    dataObject.getForm(formName).updateAllFieldsPropValue(dataObject);
  };



  render() {


    const {dataObject, rootObject, index, entities, formName, entity} = this.props;
    const fields = dataObject.getFormFields(formName);
    let {validation, configLevel, tenantGroup, tenant, user, language} = fields;



    const openContent = (
      <div>
        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...configLevel.props}  />
            <Validate field={configLevel} value={configLevel.props.value} onSuccess={this.handleConfigLevelChange}/>
          </div>

          { (lovValue(dataObject.configLevel) === CONFIGLEVEL.TENANTGROUP) ?
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...tenantGroup.props}/>
              <Validate field={tenantGroup} value={tenantGroup.props.value}/>
            </div>
            : null}

          { (lovValue(dataObject.configLevel) === CONFIGLEVEL.TENANT) ?
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...tenant.props}/>
              <Validate field={tenant} value={tenant.props.value}/>
            </div>
            : null}

          { (lovValue(dataObject.configLevel) === CONFIGLEVEL.USER) ?
            <div className="fx col-xs-12 col-sm-4">
              <StyledSelect {...user.props} async loadOptions={optionsSearch.bind(this, 'User', {})} clearable asterixForAll/>
              <Validate field={user} value={user.props.value}/>
            </div>
            : null}

          <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...language.props}/>
          </div>

        </div>
        <div className="row">
          <div className="fx col-sm-12">
            <StyledSelect {...validation.props} />
            <Validate field={validation} value={validation.props.value}/>
          </div>
        </div>

      </div>
    );


    return (
      <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} key={index} onDelete={this.onDelete} validate={this.props.validate} {...this.props} />
    );
  }
}





// WEBPACK FOOTER //
// ./src/core/metamodel/component/entityValidationList.tsx